import cashRegisterReceipts from './cash-register-receipts.json';
import counterparties from './counterparties.json';
import counterpartyAccounts from './counterparty-accounts.json';
import dashboard from './dashboard.json';
import edoTaxBenefits from './edo-tax-benifts.json';
import ikpus from './ikpus.json';
const edo = {
   'edo-cash-register-receipts': cashRegisterReceipts,
   'edo-counterparties': counterparties,
   'edo-counterparties-accounts': counterpartyAccounts,
   'edo-dashboard': dashboard,
   'edo-ikpus': ikpus,
   'edo-tax-benifts': edoTaxBenefits,
};
export default edo;
